<div class="cosmos-spinner__container">
    <ng-lottie
      [options]="options"
      class="cosmos-spinner__lottie"
    >
    </ng-lottie>
</div>
